import {
  useStyle 
} from "@/classify"
import useFieldState from "@/common/hooks/hook-wrappers/useInformedFieldStateWrapper"
import {
  TextArea as InformedTextArea 
} from "informed"
import {
  Fragment 
} from "react"
import defaultClasses from "./textArea.module.css"

const TextArea = (props) => {
  const {
    classes: propClasses,
    field,
    message,
    cols = 40,
    rows = 4,
    wrap = "hard",
    ...rest
  } = props
  const fieldState = useFieldState(field)
  const classes = useStyle(defaultClasses, propClasses)
  const inputClass = fieldState.error ? classes.input_error : classes.input

  return (
    <Fragment>
      <InformedTextArea
        cols={cols}
        rows={rows}
        wrap={wrap}
        {...rest}
        className={inputClass}
        field={field}
      />
    </Fragment>
  )
}

export default TextArea
